import React, { useCallback, useEffect, useState } from 'react'
import { Autocomplete, Box, Button, Checkbox, FormControl, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { ApiGenerateInvoice, ApiGenerateMasterInvoice, ApiGetInvoiceReportList, ApiGetShopperList } from '../../../apiService/Core/Apicall.tsx'
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { toast } from 'react-toastify';

function GenerateInvoice() {
    const [selectedShopper, setSelectedShopper] = useState<any>()
    const [searchShopper, setsearchShopper] = useState<any>([])
    const [datalength, setdatalength] = useState<any>(null);
    const [shopperlist, setshopperlist] = useState<any>([]);
    const [selectedRow, setSelectedRow] = useState<any>([]);
    const [reportlist, setreportlist] = useState<any>([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());


    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getgeneratedinvoice = async () => {
        try {
            const data = `?month=${selectedDate?.getMonth() + 1}&year=${selectedDate?.getFullYear()}`
            const res = await ApiGetInvoiceReportList(data)
            console.log("Report Data", res.data)
            setreportlist(res.data)
            // setdatalength()
        } catch (error) {
            console.log(error)
        }
    }

    const getShopperList = async (text) => {
        setshopperlist([])
        try {
            const data = `?offset=0${text?.length > 0 ? `&search=${text}` : ''}`
            const res = await ApiGetShopperList(data)
            const originonal = res.data
            console.log("Live Data", originonal)
            setshopperlist(originonal)
            const defaultselected = (res.data?.filter(item => item.firstName !== ''))
            // setSelectedShopper(defaultselected[0])

        } catch (error) {
            alert(error)
        }
    }


    useEffect(() => {
        getgeneratedinvoice()
    }, [selectedDate])


    useEffect(() => {
        getShopperList(searchShopper);
    }, [searchShopper])


    const handleSelectRow = (index: number) => {
        setSelectedRow((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };

    const generateinvoice = async () => {

        const filteredData = reportlist.filter(item => selectedRow.includes(item.reportHeaderId));

        const data = {
            month: selectedDate.getMonth() + 1,
            year: selectedDate.getFullYear(),
            createdBy: localStorage.getItem('userRole'),
            data: filteredData
        }
        try {
            const res = await ApiGenerateInvoice(data)
            toast.success(res.message)
            selectedRow([])
            getgeneratedinvoice()
        } catch (error) {
            alert(error)
        }
    }

    

    return (
        <div>
            <Box sx={{ p: 4 }} style={{ background: "white" }}>
                <Box className='w-100'>
                    <Typography className='text-center' variant='h4'> Generate Invoice</Typography>
                </Box>
                <Box className='d-flex align-items-center mt-3 justify-content-between'>
                    <FormControl size="small" className='col-3'>
                        <label htmlFor="search_shopper" className='mb-0 pl-1' style={{ fontSize: '16px' }}>Search Shopper</label>
                        <Autocomplete
                            id='serach_shopper'
                            disablePortal
                            options={shopperlist?.filter(item => item.firstName !== '')}
                            value={selectedShopper}
                            onInputChange={(event, newInputValue) => { setsearchShopper(newInputValue) }}
                            getOptionLabel={(option: any) => `${option?.firstName} ${option.lastName}`}
                            isOptionEqualToValue={(option: any, value: any) =>
                                option.userId === value.userId || option.emailId === value.emailId
                            }
                            filterOptions={(options, { inputValue }) =>
                                options.filter((option) => {
                                    const fullName = `${option.firstName} ${option.lastName}`.toLowerCase();
                                    const email = option.emailId?.toLowerCase() || '';
                                    const search = inputValue.toLowerCase();
                                    return fullName.includes(search) || email.includes(search);
                                })
                            }
                            onChange={(event, newValue: any) => {
                                setSelectedShopper(newValue)
                            }}
                            // defaultValue={shopperlist?.filter(item => item.firstName !== '')[0]}
                            renderInput={(params) => <TextField {...params} />}
                            size="small"
                        />
                    </FormControl>
                    <Box sx={{ display: "flex", justifyContent: "center", px: 2 }}>
                        {/* <OliveButton>All Report Status</OliveButton> */}

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                views={["month", "year"]}
                                label=""
                                value={selectedDate}
                                onChange={(newDate) => newDate && setSelectedDate(newDate)}
                                format="MM/yyyy"
                                sx={{
                                    width: "400px",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 1,
                                    },
                                }}
                            />
                        </LocalizationProvider>

                        {/* <OliveButton>DOWNLOAD AS XLS</OliveButton> */}
                    </Box>
                    <Box className='d-flex' gap={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                            onClick={generateinvoice}
                        >
                            Generate Invoices
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            style={{ width: "auto" }}
                          
                        >
                            Export to excel
                        </Button>
                    </Box>
                </Box>
                <Box className='w-100 mt-5'>
                    <TableContainer
                        component={Paper}
                        sx={{ mb: 4, border: "1px solid #ccc" }}
                    >
                        <Table>
                            <TableHead sx={{ bgcolor: "#7a7d52" }}>
                                <TableRow>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>DataBase</TableCell>
                                    <TableCell className='text-center' padding="checkbox" sx={{ color: "white" }}>
                                        <Checkbox
                                            indeterminate={
                                                selectedRow.length > 0 && selectedRow.length < reportlist.length
                                            }
                                            checked={reportlist.length > 0 && selectedRow.length === reportlist.length}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    // Select all rows
                                                    setSelectedRow(reportlist.map((item) => item.reportHeaderId));
                                                } else {
                                                    // Deselect all
                                                    setSelectedRow([]);
                                                }
                                            }}
                                        />

                                    </TableCell>
                                    <TableCell sx={{ color: "white" }}>Shopper Name</TableCell>
                                    <TableCell sx={{ color: "white" }}>Venue Name</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Report Date</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Score</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Price</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Food</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Bar</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Gaming</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Bottleshop</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Bonus</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Penalty</TableCell>
                                    <TableCell sx={{ color: "white", textAlign: 'center' }}>Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    reportlist.length > 0 ? (reportlist.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.allocationClientGroup}</TableCell>
                                            <TableCell className='text-'>
                                                <Checkbox
                                                    checked={selectedRow.includes(item.reportHeaderId)}
                                                    onChange={() => { handleSelectRow(item.reportHeaderId) }}
                                                /></TableCell>
                                            <TableCell>{item?.shopperName}</TableCell>
                                            <TableCell>{item?.venueName}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{(item?.reportCreatedDate).split('T')[0]}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.finalScore}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.venuePriceDisplay}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.spentFoodAmt}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.spentBarAmt}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.spentGamingAmt}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.spentBottleShopAmt}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.bonus}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.allocationClientGroup}</TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>{item?.totalAmountToPay}</TableCell>


                                        </TableRow>
                                    )))
                                        : <TableCell className='text-center' colSpan={14}><Typography>No Data Found</Typography></TableCell>
                                }

                            </TableBody>
                        </Table>

                        {/* <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={datalength}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        /> */}
                    </TableContainer>
                </Box>
            </Box>
        </div>
    )
}

export default GenerateInvoice
